import React from 'react';

/**
 * Under Bid Time on Create Auction and in the Update Auction modal (#171): how long the auction's
 * lots need at the least, and how long there is before bidding closes - from describeAuctionFit.
 * Shown as help text, and as an error when the lots do not fit, which the server refuses on save.
 *
 * A div rather than a paragraph: ModalBox (Outer/Modal.js) wraps the modal's whole body in a <p>.
 *
 * @param {{fit: Object|null}} props fit from describeAuctionFit; nothing is shown for null.
 */
export const AuctionFitNote = ({ fit }) => {
  if (!fit) return null;

  return (
    <div className={fit.fits === false ? 'err-message' : 'form-text mt-2'} aria-live="polite">
      {fit.text}
    </div>
  );
};
